import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/api.service';
import { environment } from '../../../environments/environment';

export interface DestaqueSemanaDto {
  id: string;
  imageUrl: string;
  fornecedorSlug: string;
  dataInicial: string;
  dataFinal: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

@Injectable({ providedIn: 'root' })
export class DestaqueSemanaService {
  private base = environment?.API_BASE_URL?.replace(/\/$/, '') ?? '/api/v1';

  constructor(private api: ApiService, private http: HttpClient) {}

  list(page = 1, pageSize = 20, isActive?: boolean): Observable<any> {
    const params: Record<string, any> = { page, pageSize };
    if (isActive !== undefined) {
      params['isActive'] = isActive;
    }
    return this.api.get('/admin/destaques-semana', params) as Observable<any>;
  }

  getById(id: string): Observable<DestaqueSemanaDto> {
    return this.api.get<DestaqueSemanaDto>(`/admin/destaques-semana/${id}`);
  }

  create(formData: FormData): Observable<HttpEvent<any>> {
    const req = new HttpRequest('POST', `${this.base}/admin/destaques-semana`, formData, {
      reportProgress: true,
      responseType: 'json',
    });
    return this.http.request(req);
  }

  update(id: string, payload: Partial<DestaqueSemanaDto>): Observable<any> {
    return this.api.put(`/admin/destaques-semana/${id}`, payload);
  }

  updateImage(id: string, formData: FormData): Observable<HttpEvent<any>> {
    const req = new HttpRequest('PATCH', `${this.base}/admin/destaques-semana/${id}/image`, formData, {
      reportProgress: true,
      responseType: 'json',
    });
    return this.http.request(req);
  }

  delete(id: string): Observable<any> {
    return this.api.delete(`/admin/destaques-semana/${id}`);
  }

  getActive(): Observable<DestaqueSemanaDto | null> {
    return this.api.get<DestaqueSemanaDto | null>('/destaques-semana/active');
  }
}
